import { LOGIN_PORTAL, LOGOUT, LOADING, ERROR } from "../../types";

// eslint-disable-next-line import/no-anonymous-default-export
export default (state, action) => {
    switch (action.type) {
            case LOGIN_PORTAL:          
                return {
                    ...state,
                    error: null,
                    jwt: action.payload,
                    role: JSON.parse(atob(action.payload.split('.')[1])).role
                }
            case LOGOUT:               
               return {
                    loading: false,
                    error: null,
                    access: null
               }        
           case LOADING:               
               return {
                   ...state,
                   loading: !state.loading
               }
            case ERROR:
                return {
                    ...state,
                    error: action.payload,
                    loading: false
                }
        default:
            return state;
    }
}